import { render, staticRenderFns } from "./VendorWidget.vue?vue&type=template&id=34de1228&scoped=true&"
import script from "./VendorWidget.vue?vue&type=script&lang=js&"
export * from "./VendorWidget.vue?vue&type=script&lang=js&"
import style0 from "./VendorWidget.vue?vue&type=style&index=0&id=34de1228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34de1228",
  null
  
)

export default component.exports